import logo from "./logo.svg";
import "./App.css";
import {
  getFirestore,
  collection,
  query,
  where,
  orderBy,
  doc,
  setDoc,
  getDoc,
  getDocs,
  Timestamp,
  onSnapshot,
} from "firebase/firestore";
import {
  useCollection,
  useDocumentData,
  useDocumentDataOnce,
} from "react-firebase-hooks/firestore";
import { useAuthState } from "react-firebase-hooks/auth";
import { initializeApp } from "firebase/app";
import { getAuth, signInWithEmailAndPassword, signOut } from "firebase/auth";
// Import the functions you need from the SDKs you need

import { getAnalytics } from "firebase/analytics";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

import "bootstrap/dist/css/bootstrap.min.css";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Accordion from "react-bootstrap/Accordion";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Offcanvas from 'react-bootstrap/Offcanvas';
import Container from "react-bootstrap/Container";
import ListGroup from 'react-bootstrap/ListGroup';
// import * as moment from "moment";

import { useState, useEffect } from "react";
import AccordionBody from "react-bootstrap/esm/AccordionBody";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBBzepSPN2wdZfvan5GgyeeIREAV6k5BaU",
  authDomain: "loftie-4f472.firebaseapp.com",
  databaseURL: "https://loftie-4f472.firebaseio.com",
  projectId: "loftie-4f472",
  storageBucket: "loftie-4f472.appspot.com",
  messagingSenderId: "302939981606",
  appId: "1:302939981606:web:7fcb10ed6fe46fa437a3e7",
  measurementId: "G-L8VGQXX28P",
};



// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

// const analytics = getAnalytics(firebaseApp);

const auth = getAuth(firebaseApp);



function Tools() {
  const [user, userLoading] = useAuthState(auth);

  const [versions, setVersions] = useState({});
  const [loadingVersions, setLoadingVersions] = useState(false);
  const [versionDetails, setVersionDetails] = useState({});
  const [loadingDetails, setLoadingDetails] = useState({});
  const [loftieCount, setLoftieCount] = useState(0);
  const [clockData, setClockData] = useState([])
  const [lampData, setLampData] = useState([])
  const [devices, setDevices] = useState([])


  const getVersions = async () => {
    console.log('getVersions')
    const devicesRef = collection(getFirestore(firebaseApp), "device-versions");
    const devicesSnapshot = await getDocs(devicesRef);
    const versions = {}
    let lofties = 0
    devicesSnapshot.forEach((doc) => {
      const data = doc.data();
      console.log('data', data)
      const version = data.state?.['Ver'];
      if (!versions[version]) {
        versions[version] = [];
      }
      if (version in versions) {
        versions[version].push(doc.id);
      }
      lofties++
    });
    console.log('versions', versions)
    setLoadingVersions(false);
    setVersions(versions);
    setLoftieCount(lofties);

  }

  const getDetails = async (version, deviceIds) => {
    console.log('getDetails', deviceIds)
    setLoadingDetails({ ...loadingDetails, [version]: true });
    const usersRef = collection(getFirestore(firebaseApp), "users");
    const usersSnapshot = await getDocs(usersRef);
    const usersList = usersSnapshot.docs.map((doc) => doc.data());
    console.log(usersList);
    const foundUsers = [];
    for (let i = 0; i < usersList.length; i++) {
      const user = usersList[i];
      if (user.devices && user.devices.length > 0) {
        user.devices.forEach((device) => {
          if (deviceIds.includes(device.id)) {
            foundUsers.push(user);
          }
          // if (device.id in loftieId) {
          //   foundUsers.push(user);
          // }
        });
      }
    }
    setLoadingDetails({ ...loadingDetails, [version]: false });
    setVersionDetails({ ...versionDetails, [version]: foundUsers });
  }

  useEffect(()=>{
    // Only fetch data if user is authenticated
    if (!user) return;

    const versionDocs = collection(getFirestore(firebaseApp), 'device-versions')
    const listedVersions = []
    const getData = async()=>{
      const devicesSnapshot = await getDocs(versionDocs)
      devicesSnapshot.forEach((doc)=>{
        const d = doc.data()
        const docId = doc.id
        d.id = docId
        listedVersions.push(d)
      })
      setDevices(listedVersions)
      const lampDataArray = []
      const clockDataArray = []
      listedVersions.map((dev)=>{
        const devVer = dev['id']
        if (devVer[0] == 'L'){
          lampDataArray.push(dev)
        }else{
          clockDataArray.push(dev)
        }
      })
      lampDataArray.sort((a,b)=>b.count - a.count)
      clockDataArray.sort((a,b)=>b.count-a.count)
      setClockData(clockDataArray)
      setLampData(lampDataArray)
    }
    getData()
  }, [user])
  console.log("versions", devices)

  console.log("lamp", lampData)
  const [showUsersMap, setShowUsersMap] = useState({})

  const handleClose = (versionId) => {
    setShowUsersMap({...showUsersMap, [versionId]: false})
  }
  const handleShow = (versionId) => {
    setShowUsersMap({...showUsersMap, [versionId]: true})
  }
  const [showUsers, setShowUsers] = useState(false)

  const accordianStyle = (name, data) =>{
    return(
      <Accordion>
      <Accordion.Item>
        <Accordion.Header>
          {name} Counts
        </Accordion.Header>
        <Accordion.Body>
    <Table striped>
      <tbody>
        {data.map((d)=>{
          return(
            <tr>
            <td>{d.id}</td>
            <td>Count: {d.count}</td>
            <td>Percent {d.percent}%</td>
            <td>{d?.users ? 
                                  <td>
                                  <Button variant = 'outline-info' onClick = {()=>handleShow(d.id)}>Users</Button>
                                  <Offcanvas show={showUsersMap[d.id]} onHide = {()=>handleClose(d.id)}>
                                    <Offcanvas.Header closeButton>
                                      <Offcanvas.Title>User's Emails</Offcanvas.Title>
                                    </Offcanvas.Header>
                                      <Offcanvas.Body>
                                        <ListGroup>
                                          {d?.users.map((user, index)=>{
                                            return(
                                              <ListGroup.Item key={index}>{user}</ListGroup.Item>
                                            )
                                          })}
                                        </ListGroup>
                                      </Offcanvas.Body>
                                  </Offcanvas>
                                </td> 
            
            : null} </td>
          </tr>
          )
        })}
      </tbody>
    </Table>
    </Accordion.Body>
    </Accordion.Item>
    </Accordion>

    )
  }



  if (userLoading) {
    return (
      <Container className="d-flex justify-content-center align-items-center mt-5">
        <h3>Loading...</h3>
      </Container>
    );
  }

  if (!user) {
    return (
      <Container className="d-flex justify-content-center align-items-center mt-5">
        <h3>Authentication Required</h3>
      </Container>
    );
  }

  return (<div><Container>
    <h3>Tools</h3>
    <LoftiePlusCancellations/>
  <RefurbData />
  <Accordion>
            <Accordion.Item>
              <Accordion.Header>
                Version Counts
              </Accordion.Header>
              <Accordion.Body>
                {accordianStyle("Clock", clockData)}
                {accordianStyle("Lamp", lampData)}
                {/* {accordianStyle("All", devices)} */}
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
    {/* <button onClick={() => { setLoadingVersions(true); getVersions() }} disabled={loadingVersions}>{loadingVersions ? 'Loading... (this will take a little while)' : 'Get Loftie Firmware versions (slow)'}</button> */}
    <div>
      
      {Object.keys(versions).sort((a, b) => versions[b].length - versions[a].length).map((version) => {
        return (<div><h2>{version}</h2>
          <p>{versions[version].length} ({((parseFloat(versions[version].length) / parseFloat(loftieCount)) * 100).toFixed(2)}%)</p>
          <button onClick={() => getDetails(version, versions[version])} disabled={loadingDetails[version]}>{loadingDetails[version] ? 'Loading' : 'Get Users'}</button>
          {versionDetails[version] && <ul>{versionDetails[version].map((user) => {
            return <a href={`/user?email=${user.email}`} target="_blank"><div>{user.email}</div></a>
          })}</ul>}
          <br></br><br></br>
          <hr></hr>
      
        </div>)
      })}
    </div>
  </Container>
  </div>)
}


//Refurb Data 
function RefurbData (){
  const [user] = useAuthState(auth);
  const [refurbData, setRefurbData] = useState({})
  const [returnReasons, setReturnReasons] = useState([])

  useEffect(()=>{ 
      // Only fetch data if user is authenticated
      if (!user) return;

      const refurbDataRef = doc(collection(getFirestore(firebaseApp), "refurb-data"), "cTDtS0JW1MOkvtFnocBe")
      const unsubscribe = onSnapshot(refurbDataRef, (doc)=>{
        if (doc.exists()){
          const docData =  doc.data()
          setRefurbData(docData)
          const returns = docData['return_reasons']
          returns.sort((a,b)=> b.count-a.count)
          setReturnReasons(returns)
        }
      } )

      return () => unsubscribe();
  }, [user])

  console.log(returnReasons)

  return(
    <div>
            <Accordion>
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  Return Reasons
                </Accordion.Header>
                <Accordion.Body>
                <Table striped>
                   <tbody>
                            {returnReasons.map((data)=>{
                              return(
                                <tr>
                                  <td>{data.reason}</td>
                                    <td>amount: {data.count}</td>
                                    <td>percent: {data.percent}%</td>
                                </tr>
                              )
                            })}  
                      </tbody>
                    </Table>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
    </div>
  )

}

function LoftiePlusCancellations(){
  const [subscriptionData,setSubscriptionData] = useState([])
  const [cancelReasons, setCancelReasons] = useState([])
  const [showUsersMap, setShowUsersMap] = useState({})

  useEffect(()=>{
    const subscriptionRef = doc(collection(getFirestore(firebaseApp), "sub-cancellation-details"), "J0qVLjLhHtzZFLm4FVyM")
    onSnapshot(subscriptionRef, (doc)=>{
      const docData = doc.data()
      setSubscriptionData(docData)
      const cancellations = docData['app_cancellations']
      cancellations.sort((a,b)=>b.number - a.number)
      setCancelReasons(cancellations)
    })
  },[])

  console.log("sub data", subscriptionData)

  const handleClose = (reason) => {
    setShowUsersMap({...showUsersMap, [reason]: false})
  }
  const handleShow = (reason) => {
    setShowUsersMap({...showUsersMap, [reason]:true})
  }

  return(
    <div>
        <Accordion>
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              App Cancellations
            </Accordion.Header>
            <Accordion.Body>
              <Table striped>
                <tbody>
                  {cancelReasons.map((data)=>{
                    return(
                    <tr>
                      <td>{data.reason}</td>
                      <td>amount: {data.number}</td>
                      <td>percent: {data.percent}%</td>
                      <td>
                        <Button variant = 'outline-info' onClick = {()=>handleShow(data.reason)}>Users</Button>
                        <Offcanvas show = {showUsersMap[data.reason]} onHide = {()=>handleClose(data.reason)}>
                          <Offcanvas.Header closeButton>
                            <Offcanvas.Title>User's Emails</Offcanvas.Title>
                          </Offcanvas.Header>
                            <Offcanvas.Body>
                              <ListGroup>
                                {data?.users.map((user)=>{
                                  return(
                                    <ListGroup.Item>{user}</ListGroup.Item>
                                  )
                                })}
                              </ListGroup>
                            </Offcanvas.Body>
                        </Offcanvas>
                      </td>
                    </tr>
                    )
                  })}
                  <td> current cancellations: {subscriptionData['current_cancels']}</td>
                  <td>previous cancellations: {subscriptionData['prev_cancels']}</td>
                </tbody>
              </Table>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
    </div>

  )

}

export default Tools;
